module.exports = __webpack_public_path__ + "static/media/RM007_COVER1_FORPRINT_compressed-05.42f99dee.jpg";